import { app } from '../../app';
import { Controller } from './user.controller';

app.component('user', {
    bindings: {account: '<'},
    controller: Controller,
    templateUrl: require('./user.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/user.component.js